export type ApiEnumKeyObjectResponse = {
  categories?: Array<
    | {
        /**
         * Key name
         */
        const_key: string;
        labels?: Array<{
          /**
           * Label text
           */
          label: string;
          /**
           * Label text
           */
          label_short?: string | null;
          /**
           * Language code
           */
          language: string;
        }>;
      }
    | string
  >;
  /**
   * Key name
   */
  const_key: string;
  labels: Array<{
    /**
     * Label text
     */
    label: string;
    /**
     * Label text
     */
    label_short?: string | null;
    /**
     * Language code
     */
    language: string;
  }>;
  /**
   * Patent's key
   */
  parent: string | null;
  properties?: Array<{
    /**
     * Custom property name
     */
    name: string;
    /**
     * Custom property value
     */
    value: any;
  }>;
};
